<div class="schedules-app" ui-view></div>
